import styled from "styled-components";

export const EffectStyles = styled.img`
  position: fixed;
  background-repeat: no-repeat;
  background-size: contain;
  z-index: -1;
  width: 50%;
  animation: moveEffect 20s infinite;
  opacity: 0.1;

  @keyframes moveEffect {
    0%, 100% {
      transform: translate(${(props) => props.vwStart}vw, ${(props) => props.vhStart}vh) rotate(0deg);
      opacity: 0.3;
    }
    50% {
      transform: translate(${(props) => props.vwEnd}vw, ${(props) => props.vhEnd}vh) rotate(360deg);
      opacity: 0.1;
    }
  }
`;

